// Firebase configuration for No Window Shopping
//
// NOTE: the audiobook on /mgcu/library/thirty-minutes-in-cabo uses a *different*
// Firebase project — `nwspro-9044c` — for its audio + cover hosting. Those URLs
// are hardcoded in src/mgcu/booksData.ts and do not go through this SDK config.
// The rest of the site (webstore, raffles, Firestore, auth) is on the project
// configured via REACT_APP_FIREBASE_* env vars (currently nowindowshopping-7eb37
// in Vercel — this is a Create React App build, so vars must use the REACT_APP_
// prefix, not NEXT_PUBLIC_, to be embedded in the client bundle).
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};
